import { Identifiable } from '../interface/identifiable';
import { Factory } from '../interface/factory';
import { ProductOwnershipType } from './product/product-owner';

export enum OwnerRefType {
  User = 'User',
  Organization = 'Organization',
}

export class OwnerRef implements Identifiable {
  type: OwnerRefType;
  id: string;

  constructor(json: any, type: OwnerRefType) {
    this.type = type;
    this.id = json.id;
  }

  public static getFactory(): Factory<OwnerRef> {
    return new (class implements Factory<OwnerRef> {
      make(json: any): OwnerRef {
        switch (json.type) {
          case OwnerRefType.User:
            return new UserOwnerRef(json);
          case OwnerRefType.Organization:
            return new OrganizationOwnerRef(json);
          default:
            throw new Error('Unrecognized Owner type (' + json.type + ').');
        }
      }

      getTableName(): string {
        throw new Error('Owners are never stored in IndexedDB.');
      }
    })();
  }
}

export class UserOwnerRef extends OwnerRef {
  constructor(json: any) {
    super(json, OwnerRefType.User);
  }
}

export class OrganizationOwnerRef extends OwnerRef {
  ownershipType?: ProductOwnershipType;
  constructor(json: any) {
    super(json, OwnerRefType.Organization);
  }
}
